import * as Icons from "lucide-react";
import { ACTIVITY_ICONS } from "@/lib/activities";

export default function ActivityFilters({ activities, selected, onToggle }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid="activity-filters">
      {activities.map((a) => {
        const Icon = Icons[ACTIVITY_ICONS[a.slug]] || Icons.Sparkles;
        const active = selected.includes(a.slug);
        return (
          <button
            key={a.slug}
            onClick={() => onToggle(a.slug)}
            aria-pressed={active}
            data-testid={`activity-filter-${a.slug}`}
            className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold transition-all ${
              active
                ? "bg-[#4A6B53] text-white border-[#4A6B53] shadow-sm"
                : "bg-white text-[#58625B] border-[#E5DCD0] hover:bg-[#F2EBE1] hover:text-[#2C312E]"
            }`}
          >
            <Icon size={15} strokeWidth={2.2} />
            {a.name}
          </button>
        );
      })}
    </div>
  );
}
